import "./style.less";

export default function bookingWizard() {
    return {
        restrict: "E",
        scope: {
            skipPayment: "=",
            currentStep: "=",
        },
        template: require("./template.html"),

        controller: function ($scope) {
            if ($scope.skipPayment) {
                $scope.steps = [
                    { name: "Booking", url: "/checkout/bookingoptions" },
                    { name: "Personlig Info", url: "/checkout/bookinginfo" },
                    { name: "Kvittering", url: "/checkout/booking-complete" },
                ];
            } else {
                $scope.steps = [
                    { name: "Booking", url: "/checkout/bookingoptions" },
                    { name: "Personlig Info", url: "/checkout/bookinginfo" },
                    { name: "Betaling", url: "/checkout/bookinginfo" },
                    { name: "Kvittering", url: "/checkout/payment-complete" },
                ];
            }
        },
    };
}
